/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerhandle1Inputs */

const en_organizerhandle1 = /** @type {(inputs: Organizerhandle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handle`)
};

const de_organizerhandle1 = /** @type {(inputs: Organizerhandle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzname`)
};

/**
* | output |
* | --- |
* | "Handle" |
*
* @param {Organizerhandle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerhandle1 = /** @type {((inputs?: Organizerhandle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerhandle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerhandle1(inputs)
	return de_organizerhandle1(inputs)
});
export { organizerhandle1 as "organizerHandle" }